<template>
  <div class="date-options">
    <div class="row">
      <!-- Year select -->
      <div class="col col-xs-12 col-sm-3">
        <UiSelect
          v-model="localYear"
          :options="years"
          placeholder="Год"
          :clearable="false"
          class="date-options_select"
        />
      </div>

      <!-- Month select -->
      <div class="col col-xs-12 col-sm-3">
        <UiSelect
          v-model="localMonth"
          :clearable="false"
          class="date-options_select"
          :reduce="(month) => month.value"
          label="text"
          :options="monthArray"
          placeholder="Месяц"
        />
      </div>

      <!-- Accept date button -->
      <div class="col col-xs-12 col-sm-3">
        <UiButton class="button is-blue is-outlined" @click="acceptDate"> Показать </UiButton>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/UiButton.vue'
import UiSelect from '@/components/UiSelect.vue'

import generateYearsArray from '@/utils/generateYearsArray'

import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import syncQuery from '@/mixins/syncUrlQuery'
import monthArray from '@/mixins/monthArray'

export default {
  components: { UiSelect, UiButton },
  mixins: [syncQuery],
  data() {
    return {
      month: CURRENT_MONTH.toString(),
      localMonth: '',

      year: CURRENT_YEAR.toString(),
      localYear: '',

      monthArray: monthArray,
      years: generateYearsArray(CURRENT_YEAR, 2016, -1),
    }
  },
  mounted() {
    this.syncQuery(['year', 'month'])

    this.syncComponentField('localMonth', 'month')
    this.syncComponentField('localYear', 'year')
  },
  methods: {
    acceptDate() {
      this.updateQueryParams({
        query: { month: this.localMonth, year: this.localYear },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.date-options {
  margin: 0 0 20px 0;

  &_select {
    margin: 0 0 rem(8px) 0;

    @include media_custom(656px) {
      margin: 0 rem(8px) 0 0;
    }
  }

  .col {
    padding: 0;
  }
}
</style>
